export function setRedemptionDocTypes(status ){
    let result = [
        { value: 'contractSigned', name: 'Підписаний договір', main: false },
        { value: 'contractAnnexe', name: 'Додатки до договору', main: false },
        { value: 'contractNotice', name: 'Повідомлення про договір', main: false },
    ]
    if (status === 'pending') result = [...result, { value: 'additionalAgreement', name: `Додаткова угода`, main: true } ]
    
    return result
}